// extracted by css-extract-rspack-plugin
export default {"container":"OpenInLocalAgentButton-module__container__fWL3Q","overlay":"OpenInLocalAgentButton-module__overlay__DoRO7","divider":"OpenInLocalAgentButton-module__divider__wEmtB"};